








































import { EscalatedAlert, EscalatedAlertStatus, EventType } from '@/api';
import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import SaveCancel from '@/components/elements/buttons/save-cancel-buttons.vue';
import { EscalatedAlertApiService } from '@/services/escalated-alert-service';
import Toast from '@/components/display/toast.vue';

@Component({ components: { SaveCancel } })
export default class StatusChangeModal extends Vue {
	@Prop({ required: true, type: String })
	public currentStatus!: string;

	@Prop({ required: true, type: String })
	public newStatus!: string;

	@Prop({ required: true, type: Object })
	public alert!: EscalatedAlert;

	@Prop({ required: true, type: Object })
	public event?: EventType | null;

	@Prop({ required: true, type: Number })
	public currentTemperature?: number;

	@Prop({ type: Number })
	public saveVolume!: number | null;

	// API fields
	public toast = new Toast();
	public escalatedAlertApi: EscalatedAlertApiService = new EscalatedAlertApiService();

	// Form fields

	public noteSelection: string = 'On trend with farm data';
	public resolutionReason: string = "";
	public isSave: boolean = false;
	public isValid: boolean = true;
	public saveVolumeInput: number = this.saveVolume ?? 0;
	public otherNotes: string = '';

	public get disableSave() {
		return this.otherAppear ? !this.otherValid : false;
	}

	public get otherAppear() {
		return this.noteSelection == 'Other';
	}

	public get otherValid() {
		return !!this.otherNotes;
	}

	public get isHCP() {
		return this.event ? this.event.isSpecial : false;
	}

	public get title() {
		return this.newStatus === EscalatedAlertStatus.Monitor ? this.newStatus : this.newStatus.slice(0, -1);
	}

	public get isValidLabel() {
		return this.isHCP ? "Was this a valid alert?" : "Was this a valid Milk Score?";
	}

	public HCPOptions: { value: string; text: string }[] = [
		{ value: 'Alert Not Valid', text: 'Alert Not Valid' },
	];

	public HCPValidOptions: { value: string; text: string }[] = [
		{ value: 'On Farm Trend  | No Action Required', text: 'On Farm Trend  | No Action Required' },
		{ value: 'Farmer Aware', text: 'Farmer Aware' },
		{ value: 'Duplicate Ticket', text: 'Duplicate Ticket' },
	];

	public HCPValidSaveOptions: { value: string; text: string }[] = [
		{ value: 'HCP Save', text: 'HCP Save' },
	];

	public MQIOptions: { value: string; text: string }[] = [
		{ value: 'Vat is empty', text: 'Vat is empty' },
		{ value: 'Cellular / Offline', text: 'Cellular / Offline' },
		{ value: 'Non Supply Vat', text: 'Non Supply Vat' },
		{ value: 'Other', text: 'Other' },
	];

	public MQIValidOptions: { value: string; text: string }[] = [
		{ value: 'MQI Temperature Related', text: 'MQI Temperature Related' },
		{ value: 'Milk in holding too long', text: 'Milk in holding too long' },
		{ value: 'Vat wash not valid (above 40°C)', text: 'Vat wash not valid (above 40°C)' },
		{ value: 'Other', text: 'Other' },
	];

	public get resolutionOptions(): { value: string; text: string }[] {
		return [
			...(!this.isValid && this.isHCP ? this.HCPOptions : []),
			...(this.isValid && !this.isSave && this.isHCP ? this.HCPValidOptions : []),
			...(this.isValid && this.isSave && this.isHCP ? this.HCPValidSaveOptions : []),
			...(!this.isValid && !this.isHCP ? this.MQIOptions : []),
			...(this.isValid && !this.isHCP ? this.MQIValidOptions : []),
		];
	}

	public noteOptions: { value: string; text: string }[] = [
		{ value: 'On trend with farm data', text: 'On trend with farm data' },
		{ value: 'Waiting for next data packet', text: 'Waiting for next data packet' },
		{ value: 'Power outage', text: 'Power outage' },
		{ value: 'Non-supply milk', text: 'Non-supply milk' },
		{ value: 'Duplicate Escalated Alert', text: 'Duplicate Escalated Alert' },
	];

	@Watch('isHCP')
	@Watch('isSave')
	@Watch('isValid')
	public resolutionReasonUpdater() {
		this.resolutionReason = this.resolutionOptions[0].value;
	}

	mounted() {
		this.resolutionReasonUpdater()
	}

	// Event to update escalated alerts
	@Emit('update')
	public emitUpdate() { }

	public getNotes() {
		if (this.newStatus == EscalatedAlertStatus.Escalated) return "Called Customer";
		if (this.newStatus == EscalatedAlertStatus.Resolved) return null;
		return this.otherAppear ? this.otherNotes : this.noteSelection;
	}

	public async save() {
		if (typeof this.alert.id === 'number') {
			let response;
			switch (this.newStatus) {
				case EscalatedAlertStatus.Monitor:
					response = await this.escalatedAlertApi.setEscalatedAlertToMonitor(this.alert.id, {
						notes: this.getNotes(),
						temperature: this.currentTemperature,
					});
					break;
				case EscalatedAlertStatus.Escalated:
					response = await this.escalatedAlertApi.setEscalatedAlertToEscalate(this.alert.id, {
						notes: this.getNotes(),
						temperature: this.currentTemperature,
					});
					break;
				case EscalatedAlertStatus.Resolved:
					response = await this.escalatedAlertApi.setEscalatedAlertToResolve(this.alert.id, {
						notes: this.getNotes(),
						is_save: this.isSave && this.isValid,
						is_valid: this.isValid,
						save_volume: this.isValid ? this.saveVolumeInput : null,
						temperature: this.currentTemperature,
						resolution_reason: this.resolutionReason,
					});
					break;
			}
			if (response?.escalatedAlertLog != null) {
				this.toast.makeToast(
					'Success',
					`Successfully changed to status: ${this.newStatus}`,
					'success',
					false,
				);
				this.emitUpdate();
			} else if (response?.errorMessage != null) {
				this.toast.makeToast(
					'Error',
					`There was a problem changing the status: ${response.errorMessage}`,
					'danger',
					false,
				);
			}
			this.$bvModal.hide('status-change');
		}
	}

	public close(): void {
		this.noteSelection = 'Monitored';
		this.resolutionReason = '';
		this.isSave = false;
		this.isValid = false;
		this.saveVolumeInput = this.saveVolume ?? 0;
		this.otherNotes = '';
		this.$bvModal.hide('status-change');
	}
}
